import { defineComponent, useTemplateRef, ref, inject, watch, watchEffect, onBeforeUnmount, computed, createElementBlock, openBlock, normalizeClass } from "vue";
import { createInjectionKey } from "../../utils/index.js";
import { _export_sfc } from "../WAccordion/index.js";
import './index.css';const noLottieInjectionKey = createInjectionKey();
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WLottie",
  props: {
    animationData: {},
    loop: { type: [Number, Boolean], default: false },
    autoplay: { type: Boolean, default: true },
    speed: { default: 1 },
    direction: { default: 1 },
    isCurrentColor: { type: Boolean, default: false }
  },
  emits: ["complete", "loopComplete", "enterFrame", "segmentStart", "mounted"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const container = useTemplateRef("container");
    const animation = ref();
    const noLottie = inject(noLottieInjectionKey, false);
    watch(
      container,
      () => {
        import("../../lottie.min.js").then(
          ({ default: lottie }) => {
            var _a, _b, _c, _d;
            if (noLottie) {
              return;
            }
            animation.value = lottie.loadAnimation({
              container: container.value,
              renderer: "svg",
              loop: props.loop,
              autoplay: props.autoplay,
              animationData: props.animationData
            });
            (_a = animation.value) == null ? void 0 : _a.addEventListener(
              "loopComplete",
              () => emit("loopComplete")
            );
            (_b = animation.value) == null ? void 0 : _b.addEventListener("complete", () => emit("complete"));
            (_c = animation.value) == null ? void 0 : _c.addEventListener(
              "enterFrame",
              () => emit("enterFrame")
            );
            (_d = animation.value) == null ? void 0 : _d.addEventListener(
              "segmentStart",
              () => emit("segmentStart")
            );
            emit("mounted");
          }
        );
      },
      { once: true }
    );
    const direction = ref(props.direction);
    watch(
      direction,
      (direction2) => {
        var _a;
        (_a = animation.value) == null ? void 0 : _a.setDirection(direction2);
      },
      { immediate: true }
    );
    watchEffect(() => {
      var _a;
      return (_a = animation.value) == null ? void 0 : _a.setDirection(direction.value);
    });
    watchEffect(() => {
      var _a;
      return (_a = animation.value) == null ? void 0 : _a.setSpeed(props.speed);
    });
    onBeforeUnmount(() => {
      var _a;
      (_a = animation.value) == null ? void 0 : _a.destroy();
    });
    __expose({
      direction: computed(() => direction.value),
      setDirection: (newDirection) => direction.value = newDirection,
      play: () => {
        var _a;
        return (_a = animation.value) == null ? void 0 : _a.play();
      },
      pause: () => {
        var _a;
        return (_a = animation.value) == null ? void 0 : _a.pause();
      },
      stop: () => {
        var _a;
        return (_a = animation.value) == null ? void 0 : _a.stop();
      },
      goToAndStop: (value, isFrame) => {
        var _a;
        return (_a = animation.value) == null ? void 0 : _a.goToAndStop(value, isFrame);
      },
      goToAndPlay: (value, isFrame) => {
        var _a;
        return (_a = animation.value) == null ? void 0 : _a.goToAndPlay(value, isFrame);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "container",
        ref: container,
        class: normalizeClass(["w-lottie", { "--current-color": _ctx.isCurrentColor }])
      }, null, 2);
    };
  }
});
const WLottie = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-185156d7"]]);
export {
  WLottie
};
